import Component from '../abstracts/Component';
import {isbot} from "isbot";
import WishlistLogic from "../logics/WishlistLogic";
import TrackingComponent from "./TrackingComponent";

export default class GoogleRecommendationEngineComponent extends Component {

  get SELECTORS() {
    return {
      RECOMMENDATION_ENGINE_PRODUCTS_CONTAINER: '#google-recommendation-engine-products-container',
      carouselCards: '#carouselCards',
      wishlistButton: "[data-js-wishlist]",
      nextArrow: ".next-arrow",
      prevArrow: ".prev-arrow",
    };
  }

  get CONSTANTS() {
    return {
      RECOMMENDATION_ENGINE_URL: "/action/recommendation-google",
      GET: "GET",
      POST: "POST",
      CHECKOUT_TEMPLATE: "t-checkout-confirm"
    };
  }

  constructor(compEl) {
    super(compEl);
    this.recommendationEngineProductsContainer = this.$component.querySelector(this.SELECTORS.RECOMMENDATION_ENGINE_PRODUCTS_CONTAINER);
    this.trackingComponent = new TrackingComponent();
    this.wishlistLogic = new WishlistLogic();
  }

  render() {
    this.importSlick();
    if (this.$component) {
      this.setup(this.$component);
    }
    this.wishlistLogic.render();
  }

  getMarketingOpts(recommendationComponent) {
    let opts = {};
    opts.webRecommendationHtmlData = true;
    let template = recommendationComponent.dataset.template;
    let checkoutTemplate = this.CONSTANTS.CHECKOUT_TEMPLATE;

    opts.template = template;
    opts.codes = recommendationComponent.dataset.codes;
    opts.orderCode = recommendationComponent.dataset.orderCode;
    opts.saleMode = recommendationComponent.dataset.salemode;
    if (typeof (utag_data) !== 'undefined' && utag_data !== null && template === checkoutTemplate) {
      let products = utag_data.products;
      if (typeof (products) !== 'undefined' && products !== null) {
        try {
          opts.productsData = JSON.stringify(products);
        } catch (e) {
          this.warn("error trasform products to JSON");
        }
      }
      if (typeof (utag_data.order_total) !== 'undefined' && utag_data.order_total !== null) opts.totalPrice = utag_data.order_total;
    }

    return opts;
  }

  getSimilarOpts(recommendationComponent) {
    let opts = {};
    opts.similarHtmlData = true;
    opts.template = recommendationComponent.dataset.template;
    opts.codes = recommendationComponent.dataset.codes;
    opts.saleMode = recommendationComponent.dataset.salemode;
    return opts;
  }

  moduleTitle() {
    const googleModel = this.$component.querySelector("#googleRecommendationModel");
    const googleTitle = this.$component.querySelector("#google-recommendation-title");
    if (typeof (googleModel) !== 'undefined' && googleModel !== null && googleModel.value !== '' && typeof (googleTitle) !== 'undefined' && googleTitle !== null) {
      googleTitle.innerHTML = googleModel.value;
    }
  }

  setup(recommendationComponent) {
    const userAgentString = navigator.userAgent;
    if (!isbot(userAgentString)) {
      this.fetchServer(this.getMarketingOpts(recommendationComponent));
    } else {
      this.$component.classList.add("hidden");
    }
  }

  async fetchServer(paramsObj) {
    const params = new URLSearchParams();
    for (let key in paramsObj) {
      params.append(key, paramsObj[key]);
    }
    const response = await fetch(this.CONSTANTS.RECOMMENDATION_ENGINE_URL + "?" + params.toString().replace(/\+/gi, "%20")).catch((error) => {
      console.warn(error);
    });

    if (response.ok) {
      const text = await response.text();
      if (text && text.trim() !== "") {
        this.recommendationEngineProductsContainer.innerHTML = text;
        this.initCarousel(this.recommendationEngineProductsContainer.querySelector(this.SELECTORS.carouselCards));
        this.handleWishlist(this.recommendationEngineProductsContainer);
        this.moduleTitle();
        this.$emit(this.$customEvents.CAROUSEL.carouselLoaded, {carousel: this.$component});
      } else {
        await this.tryAgain();
      }
    } else {
      await this.tryAgain();
    }
  }

  async tryAgain() {
    const opts = this.getSimilarOpts(this.$component);
    const params = new URLSearchParams();
    for (let key in opts) {
      params.append(key, opts[key]);
    }
    const response = await fetch(this.CONSTANTS.RECOMMENDATION_ENGINE_URL + "?" + params.toString().replace(/\+/gi, "%20")).catch((error) => {
      console.warn(error);
    });
    if (response.ok) {
      const text = await response.text();
      if (text && text.trim() !== "") {
        this.recommendationEngineProductsContainer.innerHTML = text;
        this.initCarousel(this.recommendationEngineProductsContainer.querySelector(this.SELECTORS.carouselCards));
        this.handleWishlist(this.recommendationEngineProductsContainer);
        this.moduleTitle();
        this.$emit(this.$customEvents.CAROUSEL.carouselLoaded, {carousel: this.$component});
      } else {
        this.$component.classList.add("hidden");
      }
    } else {
      this.$component.classList.add("hidden");
    }
  }

  // handle carousel
  initCarousel(carouselContainer = this.recommendationEngineProductsContainer.querySelector(this.SELECTORS.carouselCards)) {
    const productCards = carouselContainer.querySelectorAll(".c-carousel-product-card");
    const nextArrow = this.$component.querySelector(this.SELECTORS.nextArrow);
    const prevArrow = this.$component.querySelector(this.SELECTORS.prevArrow);

    if (productCards.length > 4) {
      nextArrow.style.display = "block";
      prevArrow.style.display = "block";
    } else {
      nextArrow.style.display = "none";
      prevArrow.style.display = "none";
    }

    const options = {
      arrows: productCards.length > 4,
      centerMode: true,
      slidesToShow: 4,
      centerPadding: "112px",
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            centerPadding: "76px",
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          arrows: false,
          settings: {
            centerPadding: "86px",
            slidesToShow: 1,
          },
        },
      ],
    };
    $(carouselContainer).slick(options);
  }

  importSlick() {
    this.moduleLoader.loadCarouselAndExecute(
      (module) => {
        // initialized after successful fetch
        //this.initCarousel();
      },
      (error) => {
        console.error("failed to load slick ", error.stack);
      },
    );
  }

  // handle click on wishlist button
  handleWishlist(cardArray) {
    const wishlistButtons = cardArray.querySelectorAll(this.SELECTORS.wishlistButton);
    if (wishlistButtons) {
      wishlistButtons.forEach((btn) => {
        const addUrl = btn.dataset.addUrl;
        const removeUrl = btn.dataset.removeUrl;
        const productCode = btn.dataset.code;
        const addedMessage = btn.dataset.addedMessage;
        const removedMessage = btn.dataset.removedMessage;
        const code = btn.dataset.code;
        btn.addEventListener("click", () => {
          const isAdding = btn.dataset.jsWishlist === "empty";
          const url = (isAdding ? addUrl : removeUrl) + code;
          fetch(url, { method: "POST" })
            .then((response) => {
              return response.json();
            })
            .then((text) => {
              if (isAdding) {
                btn.dataset.jsWishlist = "full";
                this.$emit(this.$customEvents.PRODUCT_EVENTS.addedtowish, { qty: text, elem: btn, msg: addedMessage });
                this.trackingComponent.trackAction("wishlistAdd", {code: productCode});
              } else {
                btn.dataset.jsWishlist = "empty";
                this.$emit(this.$customEvents.PRODUCT_EVENTS.removedfromwish, { qty: text.count, elem: btn, msg: removedMessage });
              }
            })
            .catch((error) => this.warn(error));
        });
      });
    }
  }
}
